<template>
  <div>
    <div v-if="!$store.state.global.device" class="text-center">
      <b-spinner></b-spinner>
    </div>
    <b-jumbotron v-if="$store.state.global.device">
      <b-container>
        <b-row>
          <b-col>
            <h1>{{ $store.state.global.device.name }}</h1>
            <h5>Device #{{ $store.state.global.device.id }}</h5>
            <p>{{ $store.state.global.device.type_name }}</p>
          </b-col>
          <b-col class="text-right">
            <b-button
              v-router-link="{ name: 'device-editor', query: { id: $route.params.id } }"
              variant="primary"
            >
              <i class="fa fa-pencil-square-o" style="font-size:20px" /> Edit Device
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-jumbotron>
    <b-container v-if="$store.state.global.device">
      <b-nav tabs class="mb-3">
        <b-nav-item :to="{ name: 'device-settings-tab' }">
          Profile
        </b-nav-item>

        <b-nav-item
          v-if="$store.state.global.device.templates"
          :to="{ name: 'device-templates-tab' }"
        >
          {{ $store.state.global.device.templates.length }} Templates
        </b-nav-item>
      </b-nav>
      <div>
        <router-view />
      </div>
    </b-container>
  </div>
</template>

<script>
import $api from "@/services/api";

export default {
  created() {
    this.$store.commit("global/clearAll");
    this.refreshData();
  },

  methods: {
    async refreshData() {
      const deviceId = this.$route.params.id;
      const device = await $api.get(`/v1/internal/devices/${deviceId}`);
      this.$store.commit("global/setDevice", device);
    }
  }
};
</script>
